<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <!-- 1. 公司名称与 Slogan -->
      <div class="footer-col-company">
        <h2 class="company-name">
          {{ isEnglish ? 'Henan Hiray Industrial Technology Co., Ltd.' : '河南汇锐工业技术有限公司' }}
        </h2>
        <p class="company-slogan">
          Low-Altitude Security &amp; Counter-UAS Solutions Provider
        </p>
        <a
          class="footer-beian"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          豫ICP备2026047109号
        </a>
      </div>

      <!-- 2. 快捷链接栏 -->
      <div class="footer-col">
        <h3 class="footer-title">{{ isEnglish ? 'Quick Links' : '快速链接' }}</h3>
        <ul class="footer-list">
          <li>
            <router-link :to="homeLink" class="footer-link">
              {{ isEnglish ? 'Home' : '首页' }}
            </router-link>
          </li>
          <li>
            <router-link :to="solutionsLink" class="footer-link">
              {{ isEnglish ? 'Counter-UAS Solutions' : '反无人机解决方案' }}
            </router-link>
          </li>
          <li>
            <router-link :to="aboutLink" class="footer-link">
              {{ isEnglish ? 'About Hiray Industrial Technology' : '关于汇锐' }}
            </router-link>
          </li>
        </ul>
      </div>

      <!-- 3. 技术与产品系列 -->
      <div class="footer-col">
        <h3 class="footer-title">{{ isEnglish ? 'Products & Series' : '产品与矩阵' }}</h3>
        <ul class="footer-list">
          <li>
            <router-link :to="detectLink" class="footer-link">
              {{ isEnglish ? 'Detection Series' : '探测 / 反无人机系列' }}
            </router-link>
          </li>
          <li>
            <router-link :to="platformLink" class="footer-link">
              {{ isEnglish ? 'Low-altitude Security Platform' : '低空安全管理平台' }}
            </router-link>
          </li>
          <li>
            <router-link :to="positionLink" class="footer-link">
              {{ isEnglish ? 'Product Positioning Matrix' : '产品定位矩阵' }}
            </router-link>
          </li>
          <li>
            <router-link :to="capabilityLink" class="footer-link">
              {{ isEnglish ? 'Product Capability Matrix' : '产品能力矩阵' }}
            </router-link>
          </li>
        </ul>
      </div>

      <!-- 4. 联系方式 -->
      <div class="footer-col">
        <h3 class="footer-title">{{ isEnglish ? 'Contact' : '联系方式' }}</h3>
        <div class="contact-info">
          <p>{{ isEnglish ? 'Room 029, 7th Floor, No.257 Boxue Road, Zhengdong New District, Zhengzhou, Henan' : '河南省郑州市郑东新区博学路257号7层029号' }}</p>
          <template v-if="isEnglish">
            <p>Mr.Feng (Overseas Mgr): +86 135 9259 6878</p>
            <p>WhatsApp: +86 135 9259 6878</p>
            <p>Tel: +86 371 86058612</p>
            <p>Mr.Wang (South China Mgr): 134 5408 0666</p>
            <p>Ms.Zhang (North China Mgr): 186 3866 1817</p>
          </template>
          <template v-else>
            <p>Tel：0371 8605 8612</p>
            <p>134 5408 0666 王先生 (南区业务经理)</p>
            <p>186 3866 1817 张小姐 (北区业务经理)</p>
            <p>135 9259 6878 冯先生 (海外业务经理)</p>
          </template>
          <p>E: evanfeng2024@163.com</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    isEnglish() {
      if (this.type === 'english') return true;
      return this.$route.query.lang === 'en';
    },
    homeLink() {
      if (this.isEnglish) {
        return { path: '/', query: { lang: 'en' } };
      }
      return '/';
    },
    solutionsLink() {
      if (this.isEnglish) {
        return { path: '/products', query: { cat: 'solution', lang: 'en' } };
      }
      return { path: '/products', query: { cat: 'solution' } };
    },
    aboutLink() {
      if (this.isEnglish) {
        return { path: '/', query: { lang: 'en' }, hash: '#about' };
      }
      return { path: '/', hash: '#about' };
    },
    detectLink() {
      if (this.isEnglish) {
        return { path: '/products', query: { cat: 'detect', lang: 'en' } };
      }
      return { path: '/products', query: { cat: 'detect' } };
    },
    platformLink() {
      if (this.isEnglish) {
        return { path: '/solutions/c-uas', query: { lang: 'en' } };
      }
      return '/solutions/c-uas';
    },
    positionLink() {
      if (this.isEnglish) {
        return { path: '/products/positioning-matrix', query: { lang: 'en' } };
      }
      return '/products/positioning-matrix';
    },
    capabilityLink() {
      if (this.isEnglish) {
        return { path: '/products/capability-matrix', query: { lang: 'en', cuas: '1' } };
      }
      return '/products/capability-matrix';
    }
  }
};
</script>

<style scoped>
/* 继承 common.css 中 .site-footer 的样式 */
</style>
